export default "<p>print-slider-tpflyer works!</p>\n"